import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

export const config = {
  pagination: false,
  rowSelection: false,
  tableType: 'antd',
  columns: [
    {
      title: 'SKU名称',
      dataIndex: 'skuName',
      width: 200,
      ellipsis: true,
      render: 'nameRender',
    },
    {
      title: 'SKU_ID',
      dataIndex: 'id',
      width: 200,
    },
    {
      title: '单位',
      dataIndex: ['unitInfo', 'unitName'],
      width: 120,
    },
    {
      title: 'SKU适用门店',
      dataIndex: 'shops',
      width: 200,
      ellipsis: true,
      render: 'shopNameRender',
    },
    {
      title: (<span>
          有效状态
          <Tooltip title="SKU无效原因可能有：供应链物料下架或删除">
            <QuestionCircleOutlined style={{ marginLeft: 4}} />
          </Tooltip>
        </span>),
      dataIndex: 'effective',
      width: 140,
      render: (v) => v ? '有效' : '无效',
      fixed: 'right',
    },
    {
      title: 'SKU状态',
      dataIndex: 'enabled',
      width: 120,
      render: 'enabledRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'keyword',
      label: 'SKU名称/ID',
    },
  ],
}

export const getConfig = (isEdit = false) => {
  console.log(isEdit)
  const columns = [...config.columns]
  if (!isEdit){
    columns.splice(4, 1, )
  }
  return {...config, columns}
}